// extracted by mini-css-extract-plugin
module.exports = {"errors":"generateOTP_errors__34z_z"};